import { C, t } from '../../Dashboard/components/dashboardConstants';

export default function BillingSettings() {
  return (
    <div style={{
      background: C.white, border: `1px solid ${C.g200}`,
      borderRadius: '20px', padding: '30px',
      display: 'flex', flexDirection: 'column', gap: '30px',
    }}>
      {/* 현재 플랜 */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <span style={t('18px', 600, C.bk)}>현재 플랜</span>
        <div style={{
          background: C.white, border: `1px solid ${C.g200}`,
          borderRadius: '16px', padding: '24px 30px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}>
          {/* 좌측: 플랜 정보 */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
              <span style={t('18px', 600, C.bk)}>프리미엄 플랜</span>
              <div style={{
                padding: '3px 10px', borderRadius: '20px',
                border: `1px solid ${C.g300}`,
              }}>
                <span style={t('13px', 500, C.bk)}>활성</span>
              </div>
            </div>
            <span style={t('15px', 400, C.sub)}>월 29,000원</span>
            <span style={t('14px', 400, C.sub)}>다음 결제일: 2024년 2월 15일</span>
          </div>

          {/* 우측: 플랜 변경 버튼 */}
          <button style={{
            height: '50px', padding: '0 40px', flexShrink: 0,
            background: C.bk, border: 'none',
            borderRadius: '10px', cursor: 'pointer',
          }}>
            <span style={t('16px', 500, C.white)}>플랜 변경</span>
          </button>
        </div>
      </div>

      {/* 결제 수단 */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <span style={t('18px', 600, C.bk)}>결제 수단</span>
        <div style={{
          background: C.white, border: `1px solid ${C.g200}`,
          borderRadius: '16px', padding: '24px 30px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
        }}>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '6px' }}>
            <span style={t('18px', 600, C.bk)}>신용카드</span>
            <span style={t('15px', 400, C.sub)}>···· ···· ···· 1234</span>
          </div>
          <button style={{
            height: '50px', padding: '0 40px', flexShrink: 0,
            background: C.g200, border: 'none',
            borderRadius: '10px', cursor: 'pointer',
          }}>
            <span style={t('16px', 500, C.bk)}>카드 변경</span>
          </button>
        </div>
      </div>

      {/* 결제 내역 */}
      <div style={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
        <span style={t('18px', 600, C.bk)}>결제 내역</span>
        <div style={{
          background: C.white, border: `1px solid ${C.g200}`,
          borderRadius: '16px', padding: '24px 30px',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between',
          cursor: 'pointer',
        }}>
          <span style={t('18px', 600, C.bk)}>결제 내역 보기</span>
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none">
            <path d="M9 18l6-6-6-6" stroke={C.g400} strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round"/>
          </svg>
        </div>
      </div>
    </div>
  );
}
